const MARQUEE_ITEMS = [
  { id: 1, text: "Use code HUEHOP10 for 10% off your first order!" },
  { id: 2, text: "COD & Easy Returns" },
  { id: 3, text: "Free Shipping on orders above ₹499!" },
  { id: 4, text: "☀️ Summer Collection Live - Shop Before It's Gone!" },
  { id: 5, text: "Moods Don't Have a Gender - Hop Into Your Hue!" },
];

// ── Items ko duplicate karo seamless loop ke liye ──────────
const DOUBLED_ITEMS = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];

const TopBanner = () => {
  return (
    <>
      {/* ── Announcement Bar ── */}
      <div
        style={{
          backgroundColor: "#000",
          overflow: "hidden",
          padding: "8px 0",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            animation: "marquee-scroll 50s linear infinite",
            whiteSpace: "nowrap",
          }}
        >
          {DOUBLED_ITEMS.map((item, index) => (
            <>
              <span style={{ color: "#888" }}>✦</span>
              <span
                key={index}
                style={{
                  fontSize: 15,
                  fontWeight: 500,
                  color: "#fff",
                  padding: "0 32px",
                  whiteSpace: "nowrap",
                  letterSpacing: 0.5,
                }}
              >
                {item.text.toUpperCase()}
              </span>
              <span style={{ color: "#888" }}>✦</span>
            </>
          ))}
        </div>

        <style>{`
          @keyframes marquee-scroll {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </div>

      {/* ── Top Bar ── */}
      {/* <div className="tf-top-bar bg_white line">
        <div className="px_15 lg-px_40">
          <div className="tf-top-bar_wrap grid-3 gap-30 align-items-center">
            <ul className="tf-top-bar_item tf-social-icon d-flex gap-10">
              <li>
                <a
                  href="https://facebook.com/huehoppers.store"
                  target="_blank"
                  rel="noreferrer"
                  className="box-icon w_28 round social-facebook bg_line"
                >
                  <i className="icon fs-12 icon-fb" />
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/huehoppers26"
                  target="_blank"
                  rel="noreferrer"
                  className="box-icon w_28 round social-instagram bg_line"
                >
                  <i className="icon fs-12 icon-instagram" />
                </a>
              </li>
            </ul>

            <div className="text-center overflow-hidden" />

            <div className="tf-top-bar_item justify-content-end d-flex">
              <a
                href="mailto:hello@huehoppers.com"
                className="top-bar-text fw-5"
                style={{ fontSize: 13 }}
              >
                hello@huehoppers.com
              </a>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default TopBanner;
